<div class="no-access">
  <h2 class="no-access__header">Sorry, you don’t have access to view this page</h2>
  <p class="no-access__info">Please contact your system administrator for more information.</p>
  <img alt="access denied" class="no-access__img" src="../../../../assets/images/error-access-denied.svg" />
</div>
